// extracted by mini-css-extract-plugin
export default {"menu":"GroupCountriesStep_menu__Uqcv9"};